export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_07.9617d255.jpg";